import React from "react"
import PropTypes from "prop-types"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import SearchInput from "./../shared/search_input"

const MyApplets = ({ onSearch, value }) => {
  const onClick = () => {
    logIFTTTNextAction("click", {
      location_type: "my_applets",
      object_type: "filter_input",
    })
  }

  return (
    <div className="ifttt-next-search">
      <SearchInput
        autoComplete="off"
        autoFocus={false}
        inputID="service-search"
        maxLength="1024"
        onChange={e => onSearch(e.target.value)}
        onClick={onClick}
        onXClick={() => onSearch("")}
        placeholder="Filter"
        value={value}
      />
    </div>
  )
}

MyApplets.propTypes = {
  onSearch: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
}

export default MyApplets
